import React from 'react';
import { SpinnerIcon } from 'glints-aries';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  display: inline-block;
  svg {
    transform-origin: 51% 53%;
    animation: ${rotate360} 1s linear infinite;
  }
`;

const Spinner = ({ color }) => (
  <Container>
    <SpinnerIcon color={color} />
  </Container>
);

Spinner.propTypes = {
  color: PropTypes.string,
};

export default React.memo(Spinner);
